require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/es7.symbol.observable.js
// module id = 1201
// module chunks = 168707334958949